export enum CelebrationType {
	Anniversary = 'work_anniversary',
	Birthday = 'birthday',
	Welcome = 'welcome',
}

export enum UserPopoverEvent {
	UserPopoverRecognizeButtonClick = 'User Popover Recognize Button Clicked',
	UserPopoverScheduleOneOnOneClicked = 'User Popover Schedule One On One Clicked',
	UserPopoverOpenOneOnOneClicked = 'User Popover Open One On One Clicked',
}
